// import { http_v2 } from '@api/client';
import { http, http_v2 } from '@api/client';
import { BaseResponse } from '@api/shared';
import { paramterize, pickResponse, pickResult } from '@api/utils';
import { ContentDetail, ContentMergeResponse } from '@lib/content';
import { ContentForm } from 'pages/content/form/content.form.types';
import { map } from 'rxjs/operators';
import {
  ContentFilterParams, ContentLogParams, ContentLogResult, ContentResult, FilterCastCrewResponse, FilterLogResponse, FilterResponse, SearchContentQuery, SearchContentResponse
} from './content-api.types';
/**
 * Create a new content on CMDB.
 * @param content The content body to create
 */
export function create(content: Partial<ContentDetail>) {
  return http_v2.post<ContentResult>(`/content`, content).pipe(pickResponse());
}
export function search(query: SearchContentQuery, vtr_id: number) {
  const params = paramterize(query);
  return http_v2
    .get<SearchContentResponse>(`/content/search/${vtr_id}`, {
      params,
    })
    .pipe(pickResponse());
}
/**
 * Get the deal details from the server.
 * @param vtr_id The id of the deal to get
 */
export function get(vtr_id: string) {
  return http_v2.get<ContentResult>(`/content/${vtr_id}`).pipe(pickResult());
  // return of(singleDealResponse);
}
/**
 * Merge deals.
 * @param data The merge request model.
 */
// export function merge(data: ContentDetail) {
//   return http_v2.put<BaseResponse<ContentDetail>>('/content/related', data).pipe(pickResponse());
// }
/**
 * Deletes the given deal.
 * @param content The deal id or the actual deal.
 */
export function remove(content: Partial<ContentDetail>) {
  return http_v2
    .delete<ContentDetail>(
      `/content/${content.vtr_id}`
    )
    .pipe(pickResponse());
}
/**
 * Updates the given deal.
 * @param content The deal to update
 */
export function update(content: Partial<ContentDetail>) {
  return http_v2.put<ContentDetail>(`/content/${content.vtr_id}`, content).pipe(pickResponse());
}
/**
 * Filter companies using dynamic operators.
 * @param option Query options
 */
export function filter({
  filters = [],
  pageSize: page_size = 10,
  page = 1,
  sortBy = [],
}: ContentFilterParams = {}) {
  const isContentSort = (key: string) =>
    ['release_date', 'runtime', 'deal_count', 'vote_average', 'companies_count'].includes(key);

  const sort = sortBy
    .filter(({ id }) => !isContentSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  const sort_content_card = sortBy
    .filter(({ id }) => isContentSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  // const filtersMap: Record<string, string> = filters.reduce(
  //   (map, f) =>
  //     Object.assign(map, {
  //       [f.id]: Object.entries(f.value)
  //         .map(([op, v]) => {
  //           return op === '$bw'
  //             ? `$gte|||${v[0]};$lte|||${v[1]}`
  //             : op === '$in' &&
  //               (f.id === 'vtr_company_type_id' ||
  //                 f.id === 'vtr_company_subtype_id' ||
  //                 f.id === 'vtr_company_services_id')
  //             ? `$in|||${v
  //                 .split(',')
  //                 .map(v => v.split('|||')[0])
  //                 .join(',')}`
  //             : `${op}|||${v}`;
  //         })
  //         .join(';'),
  //     }),
  //   {}
  // );
  // const sort = sortBy
  //   // .filter(
  //   //   ({ id }) =>
  //   //     !isCompanySort(id) && !isContentSort(id) && !isClientSort(id) && !isServiceNameSort(id)
  //   // )
  //   .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
  //   .join(';');
  // const sort_content_card = sortBy
  //   // .filter(
  //   //   ({ id }) =>
  //   //     !isCompanySort(id) && !isContentSort(id) && !isClientSort(id) && !isServiceNameSort(id)
  //   // )
  //   .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
  //   .join(';');

  /////

  const newFilters = filters; //updateFiltersForLinkedOperator(filters);
  const filtersMap: Record<string, string> = newFilters.reduce(
    (map, f) =>
      Object.assign(map, {
        [f.id]: Object.entries(f.value)
          .map(([op, v]) => {
            return op === '$bw'
              ? `$gte|||${v[0]};$lte|||${v[1]}`
              : op === '$in' && f.id === 'service_provided_id'
              ? `$in|||${v
                  .split(',')
                  .map(v => v.split('|||')[0])
                  .join(',')}`
              : `${op}|||${(v || '').trim()}`;
          })
          .join(';'),
      }),
    {}
  );

  const params = paramterize({ page_size, page, sort, sort_content_card, ...filtersMap });

  return http_v2.get<FilterResponse>('/content', { params }).pipe(pickResponse());
  // return of({
  //   page_size: 1,
  //   page: 1,
  //   count: 1,
  //   data: [
  //     {
  //       vtr_id: '18a56a2d943c9a5f7c5f7909aff6cbac9c0c8eff9c34c298d4c6fe16',
  //       title: 'Among the Black Waves',
  //       type: 1,
  //       genres: 'Animation',
  //       lang_names: 'Russian',
  //       original_title: 'Маугли',
  //       country_names: 'Russia',
  //       release_year: 2016.0,
  //       production_year: 1990,
  //       number_of_seasons: 3,
  //       ratings: 3.9,
  //       deal_count: 0,
  //       companies_count: 0,
  //       modified_at: '2021-04-17T06:31:32.214Z',
  //       poster_path: '/5OdmCHSey9LcmfFXpPVqk6MKGAe.jpg',
  //     },
  //     {
  //       vtr_id: '308b33036a9561da2fa918c480dcb981e0eee39370bb0421d181c25c',
  //       title: '',
  //       original_title: 'The Magician',
  //       type: 0,
  //       genres: 'Comedy,Drama',
  //       lang_names: 'Turkish',
  //       country_names: 'Turkey',
  //       release_year: 2006.0,
  //       production_year: 1990,
  //       number_of_seasons: 0,
  //       ratings: 4.1,
  //       deal_count: 10,
  //       companies_count: 7,
  //       modified_at: '2021-04-03T06:31:30.923Z',
  //       poster_path: '/uveL2312rYyvgvNY2rc2VAGJ3QU.jpg',
  //     },
  //     {
  //       vtr_id: 'f7b2e1edb9030d9fb15a3fa3eef4a96961e909b84681d3509b8a7ef9',
  //       title: 'A Few Tunes Going Out',
  //       type: 0,
  //       genres: null,
  //       lang_names: 'English',
  //       country_names: null,
  //       release_year: 1984.0,
  //       production_year: 1990,
  //       number_of_seasons: null,
  //       ratings: 2.7,
  //       deal_count: 5,
  //       companies_count: 0,
  //       modified_at: '2021-03-14T06:31:23.274Z',
  //       poster_path: null,
  //     },
  //     {
  //       vtr_id: '34a41e6f580ff9a32b276beb08e7bd092787c1854ea197d83e9be0e9',
  //       title: 'The Story of Little Mook',
  //       type: 0,
  //       genres: 'Fantasy,Family',
  //       lang_names: 'German',
  //       country_names: 'Germany',
  //       release_year: 1953.0,
  //       production_year: 1990,
  //       number_of_seasons: 0,
  //       ratings: 1.7,
  //       deal_count: 0,
  //       companies_count: 5,
  //       modified_at: '2021-05-01T06:31:33.451Z',
  //       poster_path: '/SffPeWjBxXksPU5ANFBXviiqik.jpg',
  //     },
  //     {
  //       vtr_id: '19fe46e8ece9a51107f53ecfc0b8a1611c295fce92d77962dfaeaf69',
  //       title: 'Hell Ride',
  //       type: 0,
  //       genres: 'Action,Thriller',
  //       lang_names: 'English',
  //       country_names: '',
  //       release_year: 2008.0,
  //       production_year: 1990,
  //       number_of_seasons: 0,
  //       ratings: 2.9,
  //       deal_count: 0,
  //       companies_count: 17,
  //       modified_at: '2021-04-19T07:00:49.408Z',
  //       poster_path: '/ymIdzLutGwEyjlLLx03IrEaRvHJ.jpg',
  //     },
  //     {
  //       vtr_id: 'b7e0c2b859f20f128e3d3992aee3c28b6f41ee406d43696b1949cc7f',
  //       title: 'Train Man',
  //       type: 0,
  //       genres: 'Comedy,Romance',
  //       lang_names: 'Japanese',
  //       country_names: 'Japan',
  //       release_year: 2005.0,
  //       production_year: 1990,
  //       number_of_seasons: 0,
  //       ratings: 4.7,
  //       deal_count: 1,
  //       companies_count: 6,
  //       modified_at: '2021-05-01T06:31:33.451Z',
  //       poster_path: '/2ApHj6zklfNvo5d31GPiBDXTmJs.jpg',
  //     },
  //     {
  //       vtr_id: '1cbd14264858acf87a511556ee74a2f607632edb1170f54df45a441b',
  //       title: 'Fashion Health Story',
  //       type: 0,
  //       genres: 'Comedy,Romance',
  //       lang_names: 'English',
  //       country_names: 'Japan',
  //       release_year: 1991.0,
  //       production_year: 1990,
  //       number_of_seasons: null,
  //       ratings: 4.7,
  //       deal_count: 0,
  //       companies_count: 0,
  //       run_time: 100,
  //       modified_at: '2021-05-01T06:31:33.451Z',
  //       poster_path: '/dC3omk2RGY7qyD59GisKMI95SLc.jpg',
  //     },
  //     {
  //       vtr_id: '7fbb6359ca3afd972c124d45a239a88ccf97fea61c4d87213d2fc8fb',
  //       title: 'Departure',
  //       type: 0,
  //       genres: null,
  //       lang_names: 'English',
  //       country_names: null,
  //       release_year: 1991.0,
  //       production_year: 1990,
  //       number_of_seasons: null,
  //       ratings: null,
  //       deal_count: 0,
  //       companies_count: 0,
  //       modified_at: '2021-03-13T06:31:27.434Z',
  //       poster_path: null,
  //     },
  //     {
  //       vtr_id: '77633322c866aaf045a18dc1eb828f2cd30c1a1aa713d9aee1667b00',
  //       title: 'Light Hit',
  //       type: 0,
  //       genres: null,
  //       lang_names: 'English',
  //       country_names: null,
  //       release_year: 1995.0,
  //       production_year: 1990,
  //       number_of_seasons: null,
  //       ratings: null,
  //       deal_count: 1,
  //       companies_count: 0,
  //       modified_at: '2021-04-03T06:31:30.923Z',
  //       poster_path: null,
  //     },
  //   ],
  // });
}

export function filter_compact({
  filters = [],
  pageSize: page_size = 10,
  page = 1,
  sortBy = [],
}: ContentFilterParams = {}) {
  const isContentSort = (key: string) =>
    ['release_date', 'runtime', 'deal_count', 'vote_average'].includes(key);

  const sort = sortBy
    .filter(({ id }) => !isContentSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  const sort_content_card = sortBy
    .filter(({ id }) => isContentSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  const newFilters = filters; //updateFiltersForLinkedOperator(filters);
  const filtersMap: Record<string, string> = newFilters.reduce(
    (map, f) =>
      Object.assign(map, {
        [f.id]: Object.entries(f.value)
          .map(([op, v]) => {
            return op === '$bw'
              ? `$gte|||${v[0]};$lte|||${v[1]}`
              : op === '$in' && f.id === 'service_provided_id'
              ? `$in|||${v
                  .split(',')
                  .map(v => v.split('|||')[0])
                  .join(',')}`
              : `${op}|||${(v || '').trim()}`;
          })
          .join(';'),
      }),
    {}
  );

  const params = paramterize({ page_size, page, sort, sort_content_card, ...filtersMap });

  return http_v2.get<FilterResponse>('/content/searches_compact', { params }).pipe(pickResponse());
}

export function filter_content_cast_crew_compact({
  filters = [],
  pageSize: page_size = 10,
  page = 1,
  sortBy = [],
}: ContentFilterParams = {}) {
  const isContentSort = (key: string) =>
    ['release_date', 'runtime', 'deal_count', 'vote_average'].includes(key);

  const sort = sortBy
    .filter(({ id }) => !isContentSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  const sort_content_card = sortBy
    .filter(({ id }) => isContentSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  const newFilters = filters; //updateFiltersForLinkedOperator(filters);
  const filtersMap: Record<string, string> = newFilters.reduce(
    (map, f) =>
      Object.assign(map, {
        [f.id]: Object.entries(f.value)
          .map(([op, v]) => {
            return op === '$bw'
              ? `$gte|||${v[0]};$lte|||${v[1]}`
              : op === '$in' && f.id === 'service_provided_id'
              ? `$in|||${v
                  .split(',')
                  .map(v => v.split('|||')[0])
                  .join(',')}`
              : `${op}|||${(v || '').trim()}`;
          })
          .join(';'),
      }),
    {}
  );

  const params = paramterize({ page_size, page, sort, sort_content_card, ...filtersMap });

  return http_v2
    .get<FilterCastCrewResponse>('/content/searches_compact_cast_crew', { params })
    .pipe(pickResponse());
}

export function content_dedupe_get({
  filters = [],
  pageSize: page_size = 10,
  page = 1,
  sortBy = [],
}) {
  const isCompanySort = (key: string) =>
    [
      'deals',
      'projects_count',
      'projects_count_2000',
      'number_of_services',
      'clients_count',
    ].includes(key);

  const sort = sortBy
    .filter(({ id }) => isCompanySort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  const sort_content_details = sortBy
    .filter(({ id }) => !isCompanySort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

    const filtersMap: Record<string, string> = filters.reduce(
      (map, f) =>
        Object.assign(map, {
          [f.id]: Object.entries(f.value)
            .map(([op, v]) => {
              return op === '$bw'
                ? `$gte|||${v[0]};$lte|||${v[1]}`
                : op === '$in' &&
                  (f.id === 'vtr_company_type_id' ||
                    f.id === 'vtr_company_subtype_id' ||
                    f.id === 'vtr_company_services_id')
                ? `$in|||${(v as string
                    ).split(',')
                    .map(v => v.split('|||')[0])
                    .join(',')}`
                : `${op}|||${((v || '') as string).trim()}`;
            })
            .join(';'),
        }),
      {}
    );

  const params = paramterize({ page_size, page, sort, sort_content_details, ...filtersMap});

  const getArr = <T>(val: T): T => (Array.isArray(val) ? val : ([] as any));
  const sortTypes = (a, b) => (a?.order_id || 0) - (b?.order_id || 0);

  return http.get<FilterResponse>('/content-dedupe', { params }).pipe(
    pickResponse(),
    // Sort company types/subtypes.
    map(res => ({
      ...res,
      data: {
        ...res.data,
        data: (Array.isArray(res?.data?.data) ? res.data.data : []).map(val => ({
          ...val,
        })),
      },
    }))
  );
}

export function merge(content: ContentForm, toMerge: string[]) {
  return http
    .post<BaseResponse<ContentMergeResponse>>('/content-dedupe', {
      new_content_data: content,
      content_ids: toMerge,
    })
    .pipe(pickResult());
  }

/**
 * Get the content details from the server.
 * @param vtr_id The id of the content to get
 * @param  page
 * @param page_size
 * @param user_id //optional - based on user_id filter selected
 * @param column_name //optional- based on column-name filters selected
 */
export function getContentLogs(params:ContentLogParams) {
  return http_v2.get<FilterLogResponse>(`/content/logs`,{params}).pipe(pickResponse(),
    map(res => ({
      ...res,
      data: {
        ...res.data,
        data: (Array.isArray(res?.data?.data) ? res.data.data : []).map(val => ({
          ...val,
        })),
      },
    })));
}


/**
 * Get the user Id who edited the content from the server.
 */
export function getContentLogUserId(vtr_id: string) {
  return http_v2.get(`/content/logs/users?vtr_id=${vtr_id}`).pipe(
    pickResponse(),
    map(res => {
      return res?.data?.users || [];
    })
  );
}

export function getContentColumnName() {
  return http_v2.get(`/content/columns`).pipe(
    pickResponse(),
    map(res => {
      return res?.data?.columns || [];
    })
  );
}
